import { Component, OnInit } from '@angular/core';
import { MonthlyBill } from 'src/app/models/billing/BillingAccountInfo';
import { BillingAccountService } from 'src/app/services/BillingAccount/billing-account.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { DetectlocationService } from 'src/app/services/detectlocation.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-myaccountbills',
  templateUrl: './myaccountbills.component.html',
  styleUrls: ['./myaccountbills.component.css']
})
export class MyaccountbillsComponent implements OnInit {
  
  bills:MonthlyBill[] = [];
  currency: string;
  constructor( private billservice : BillingAccountService,public utilService : UtilService,
    private headerinfo: ComponentheaderService, private locationService: DetectlocationService,) { }

  async ngOnInit(): Promise<void> {
    this.currency = await this.locationService.getCurrencyString();
    this.headerinfo.setHeaderDisplay(
      'Bills',
      [
        { displaytext: "Account Bills", route: `/billing/bills` }
      ],
      []);

    this.billservice.getAllMonthlyBills().toPromise().then(
      (response:any) => { 
        this.bills =  response;
        console.log("bills", response);
      }
    )
  }

}
